export default {
    namespaced: true,
    state: {
        monitor_map: [],
        is_monitor_open_emap: false,

        monitor_alert: {
            id: 'table_geojson',
            alert_content: {},
            file_path: '',
        },

        focal_sign_number: ''
    },
    mutations: {
        set_is_monitor_open_emap(state, is_monitor_open_emap) {
            state.is_monitor_open_emap = is_monitor_open_emap;
        },

        set_monitor_alert(state, new_monitor_alert) {
            state.monitor_alert = {
                ...state.monitor_alert,
                ...new_monitor_alert,
            }
        },

        set_focal_sign_number(state, new_state_sign_number) {
            if (!state.is_monitor_open_emap) return
            state.focal_sign_number = new_state_sign_number;
        },

        set_monitor_map(state, new_monitor_map) {
            state.monitor_map = new_monitor_map;
        }
    },
    actions: {

    },
    getters: {

    },
}